import _ from 'lodash';
import Vue from 'vue';
import VueRouter from 'vue-router';
import { E_ROUTE_NAME } from './route.type';
import { OFFICIAL_URL } from 'library-components/constant/urls';
Vue.use(VueRouter);
function getDefault(m) {
    return m.default ? m.default : m;
}
const routes = [
    {
        path: '',
        name: 'rootRoute',
        meta: {
            istrun: true,
        },
        redirect: '/register',
    },
    {
        path: '/forgetPassword',
        name: E_ROUTE_NAME.FORGET_PASSWORD_SMS,
        component: () => import(/* webpackChunkName: "forgetPassword" */ '@/presentation/pages/ForgetPassword/ForgetPassword.vue').then(getDefault),
        meta: {
            title: 'passport.forget_password',
        },
    },
    {
        path: '/forgetPasswordEmail',
        name: E_ROUTE_NAME.FORGET_PASSWORD_EMAIL,
        component: () => import(/* webpackChunkName: "ForgetPasswordEmail" */ '@/presentation/pages/ForgetPasswordEmail/ForgetPasswordEmail.vue').then(getDefault),
        meta: {
            title: 'passport.forget_password',
        },
    },
    {
        path: '/register',
        name: E_ROUTE_NAME.REGISTER,
        component: () => import(/* webpackChunkName: "register" */ '@/presentation/pages/Register/Register.vue').then(getDefault),
        meta: {
            title: 'passport.register.register',
        },
    },
    {
        path: '/register/:inviteCode',
        name: E_ROUTE_NAME.REGISTER_INVITE,
        component: () => import(/* webpackChunkName: "register" */ '@/presentation/pages/Register/Register.vue').then(getDefault),
        meta: {
            title: 'passport.register.register',
        },
    },
    {
        path: '/registerTrialEmbed',
        name: E_ROUTE_NAME.REGISTER_TRIAL_EMBED,
        component: () => import(/* webpackChunkName: "registerTrialEmbed" */ '@/presentation/pages/RegisterTrialEmbed/RegisterTrialEmbed.vue').then(getDefault),
        meta: {
            title: 'passport.register.applyForTrial',
        },
    },
    {
        path: '/registerForFree',
        name: E_ROUTE_NAME.REGISTER_FOR_FREE,
        component: () => import(/* webpackChunkName: "registerForFree" */ '@/presentation/pages/RegisterForFree/RegisterForFree.vue').then(getDefault),
        meta: {
            /**
             * $t('passport.register.freeRegisterTitle')
             */
            title: 'passport.register.freeRegisterTitle',
        },
    },
    {
        path: '/active',
        name: E_ROUTE_NAME.ACTIVE,
        component: () => import(/* webpackChunkName: "active" */ '@/presentation/pages/Active/Active.vue'),
        meta: {
            // this.$t('passport.public.Activation')
            title: 'passport.public.Activation',
        },
    },
    {
        path: '/a/:code',
        name: E_ROUTE_NAME.ACTIVATION,
        component: () => import(/* webpackChunkName: "activation" */ '@/presentation/pages/Activation/Activation.vue'),
        meta: {
            // this.$t('passport.public.Activation')
            title: 'passport.public.Activation',
        },
    },
    {
        path: '/unlockUser',
        name: E_ROUTE_NAME.UnlockUser,
        component: () => import(/* webpackChunkName: "tipOperator" */ '@/presentation/pages/TipOperator/TipOperator.vue'),
        meta: {
            // $t('passport.public.accountManage')
            title: 'passport.public.Activation',
        },
    },
    {
        path: '/unlock',
        name: E_ROUTE_NAME.Unlock,
        component: () => import(/* webpackChunkName: "tipOperator" */ '@/presentation/pages/TipOperator/TipOperator.vue'),
        meta: {
            // $t('passport.public.accountManage')
            title: 'passport.public.accountManage',
        },
    },
    {
        path: '/resendActive',
        name: E_ROUTE_NAME.ResendActive,
        component: () => import(/* webpackChunkName: "tipOperator" */ '@/presentation/pages/TipOperator/TipOperator.vue'),
        meta: {
            // $t('passport.public.accountManage')
            title: 'passport.public.accountManage',
        },
    },
    {
        path: '/resetPassword',
        name: E_ROUTE_NAME.RESET_PASSWORD,
        component: () => import(/* webpackChunkName: "resetPassword" */ '@/presentation/pages/ResetPassword/ResetPassword.vue'),
        meta: {
            // $t('passport.public.resetPassword')
            title: 'passport.public.resetPassword',
        },
    },
    {
        path: '/SSOUserProfile',
        name: E_ROUTE_NAME.SSO_USER_PROFILE,
        component: () => import(/* webpackChunkName: "SSOUserProfile" */ '@/presentation/pages/SSOUserProfile/SSOUserProfile.vue'),
    },
    {
        path: '/dingTalkLandingPage',
        name: E_ROUTE_NAME.DING_TALK_LANDING_PAGE,
        component: () => import(/* webpackChunkName: "dingTalkLandingPage" */ '@/presentation/pages/thirdPartySSO/dingTalkLandingPage/dingTalkLandingPage.vue'),
    },
    {
        path: '/weChatLandingPage',
        name: E_ROUTE_NAME.WE_CHAT_LANDING_PAGE,
        component: () => import(/* webpackChunkName: "weChatLandingPage" */ '@/presentation/pages/thirdPartySSO/weChatLandingPage/weChatLandingPage.vue'),
    },
    {
        path: '/feiShuLandingPage',
        name: E_ROUTE_NAME.FEI_SHU_LANDING_PAGE,
        component: () => import(/* webpackChunkName: "feiShuLandingPage" */ '@/presentation/pages/thirdPartySSO/feiShuLandingPage/feiShuLandingPage.vue'),
    },
    {
        path: '/thirdPartySSOTransferPage',
        name: E_ROUTE_NAME.THIRD_PARTY_SSO_TRANSFER_PAGE,
        component: () => import(/* webpackChunkName: "thirdPartySSOTransferPage" */ '@/presentation/pages/thirdPartySSO/thirdPartySSOTransferPage/thirdPartySSOTransferPage.vue'),
    },
    {
        path: '/eventPromotionRegistration/:promotion_invitation_code',
        name: E_ROUTE_NAME.EVENT_PROMOTION_REGISTRATION,
        component: () => import(/* webpackChunkName: "eventPromotionRegistration" */ '@/presentation/pages/EventPromotionRegistration/EventPromotionRegistration.vue'),
    },
    {
        path: '/eventPromotionRegistrationEmbed/:promotion_invitation_code',
        name: E_ROUTE_NAME.EVENT_PROMOTION_REGISTRATION_EMBED,
        component: () => import(/* webpackChunkName: "eventPromotionRegistrationEmbed" */ '@/presentation/pages/EventPromotionRegistrationEmbed/EventPromotionRegistrationEmbed.vue'),
    },
    {
        path: '/unsubscribe',
        name: E_ROUTE_NAME.UNSUBSCRIBE,
        component: () => import(/* webpackChunkName: "eventPromotionRegistrationEmbed" */ '@/presentation/pages/Unsubscribe/Unsubscribe.vue'),
    }
];
const router = new VueRouter({
    mode: 'hash',
    base: '/public',
    routes,
});
router.beforeEach((to, from, next) => {
    // 移除试用注册页，原地址直接跳转到官网
    if (to.path === '/registerTrial') {
        window.location.href = OFFICIAL_URL;
        return;
    }
    if (!to.name && _.startsWith(to.path, '/register')) {
        return next('/register');
    }
    next();
});
export default router;
